import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

const PutProfileImageRequestSchema = z
  .object({
    profileImage: z.instanceof(File),
  })
  .describe('PutProfileImageRequestSchema');

const PutProfileImageResponseDataSchema = z
  .object({
    curatorId: z.string(),
    imageUrl: z.string(),
  })
  .describe('PutProfileImageResponseDataSchema');

const PutProfileImageResponseSchema = createApiResponseSchema(PutProfileImageResponseDataSchema);

type PutProfileImageRequest = z.infer<typeof PutProfileImageRequestSchema>;
type PutProfileImageResponse = z.infer<typeof PutProfileImageResponseSchema>;

export const putProfileImage = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PutProfileImageRequestSchema),
    (request: PutProfileImageRequest) =>
      executeStandardRequest(async () => {
        const formData = new FormData();
        formData.append('profileImage', request.profileImage);

        return privateHttpClient.put<PutProfileImageResponse>(
          profileApiPath.putProfileImage,
          formData as unknown as Record<string, unknown>,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );
      }),
    validateApiResponse(PutProfileImageResponseSchema),
  ),
);
